module.exports = __webpack_public_path__ + "69fb769b3712a93be9ad557ad237b7d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-anchor.png
// module id = 2861
// module chunks = 0